/**
 * @generated SignedSource<<bc4ac5acb20ae146e08f88b8ccb2725f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type JobPostingManagerField_Query$variables = {
  editable: boolean;
};
export type JobPostingManagerField_Query$data = {
  readonly currentUser?: {
    readonly firms: ReadonlyArray<{
      readonly contracts: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly freelancer: {
              readonly name: string | null | undefined;
              readonly rawId: number | null | undefined;
            } | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    }> | null | undefined;
    readonly managerContract: {
      readonly isFirmAdmin: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type JobPostingManagerField_Query = {
  response: JobPostingManagerField_Query$data;
  variables: JobPostingManagerField_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "editable"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFirmAdmin",
  "storageKey": null
},
v2 = [
  {
    "kind": "Literal",
    "name": "filters",
    "value": {
      "allowHireJobsAccess": true,
      "statuses": [
        "active",
        "paused"
      ]
    }
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rawId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "JobPostingManagerField_Query",
    "selections": [
      {
        "condition": "editable",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "currentUser",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Contract",
                "kind": "LinkedField",
                "name": "managerContract",
                "plural": false,
                "selections": [
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Firm",
                "kind": "LinkedField",
                "name": "firms",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v2/*: any*/),
                    "concreteType": "ContractConnection",
                    "kind": "LinkedField",
                    "name": "contracts",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContractEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Contract",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "freelancer",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "contracts(filters:{\"allowHireJobsAccess\":true,\"statuses\":[\"active\",\"paused\"]},first:1000)"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "JobPostingManagerField_Query",
    "selections": [
      {
        "condition": "editable",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "currentUser",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Contract",
                "kind": "LinkedField",
                "name": "managerContract",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Firm",
                "kind": "LinkedField",
                "name": "firms",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v2/*: any*/),
                    "concreteType": "ContractConnection",
                    "kind": "LinkedField",
                    "name": "contracts",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContractEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Contract",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "freelancer",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v4/*: any*/),
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "contracts(filters:{\"allowHireJobsAccess\":true,\"statuses\":[\"active\",\"paused\"]},first:1000)"
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "452eb8b2b7bc86a901e98904e0072f8f",
    "id": null,
    "metadata": {},
    "name": "JobPostingManagerField_Query",
    "operationKind": "query",
    "text": "query JobPostingManagerField_Query(\n  $editable: Boolean!\n) {\n  currentUser @include(if: $editable) {\n    managerContract {\n      isFirmAdmin\n      id\n    }\n    firms {\n      contracts(filters: {allowHireJobsAccess: true, statuses: [active, paused]}, first: 1000) {\n        edges {\n          node {\n            freelancer {\n              rawId\n              name\n              id\n            }\n            id\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e6a2ceb4d33098a0535e44e7e4aae112";

export default node;
